/* HAND-AUTHORED (the artifact pipeline was unavailable for this stage) — stage "x-nats".
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. */

import type { NodeDef } from '../../types';

export const N_X_NATS: NodeDef = {
  "id": "x-nats",
  "tagKey": "path:x-nats.tag",
  "x": 1420,
  "y": 40,
  "w": 176,
  "h": 88,
  "titleKey": "path:x-nats.title",
  "subKey": "path:x-nats.sub",
  "blocks": [
    {
      "id": "x-nats.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:x-nats.b1.title",
      "bodyKey": "path:x-nats.b1.body",
      "flowKey": "path:x-nats.b1.flow",
      "read": [
        "natsdocs"
      ]
    },
    {
      "id": "x-nats.b2",
      "kind": "tree",
      "xp": 25,
      "titleKey": "path:x-nats.b2.title",
      "tree": {
        "qKey": "path:x-nats.b2.tree.q",
        "branches": [
          {
            "tone": "pass",
            "aKey": "path:x-nats.b2.tree.b.0.a",
            "verdictKey": "path:x-nats.b2.tree.b.0.verdict"
          },
          {
            "tone": "warn",
            "aKey": "path:x-nats.b2.tree.b.1.a",
            "verdictKey": "path:x-nats.b2.tree.b.1.verdict"
          },
          {
            "tone": "stop",
            "aKey": "path:x-nats.b2.tree.b.2.a",
            "verdictKey": "path:x-nats.b2.tree.b.2.verdict"
          },
          {
            "tone": "pass",
            "aKey": "path:x-nats.b2.tree.b.3.a",
            "verdictKey": "path:x-nats.b2.tree.b.3.verdict"
          }
        ]
      }
    },
    {
      "id": "x-nats.b3",
      "kind": "check",
      "xp": 30,
      "titleKey": "path:x-nats.b3.title",
      "ex": {
        "type": "choice",
        "options": [
          {
            "tKey": "path:x-nats.b3.ex.options.0.t",
            "ok": true,
            "fbKey": "path:x-nats.b3.ex.options.0.fb"
          },
          {
            "tKey": "path:x-nats.b3.ex.options.1.t",
            "ok": false,
            "fbKey": "path:x-nats.b3.ex.options.1.fb"
          },
          {
            "tKey": "path:x-nats.b3.ex.options.2.t",
            "ok": false,
            "fbKey": "path:x-nats.b3.ex.options.2.fb"
          },
          {
            "tKey": "path:x-nats.b3.ex.options.3.t",
            "ok": false,
            "fbKey": "path:x-nats.b3.ex.options.3.fb"
          }
        ]
      }
    }
  ],
  "extra": true,
  "parent": "event-bus"
};